import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { AUTOMATIC_EXPIRATION_PROMOTION_SETTINGS_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const updateAutomaticExpirationPromotionSettingStatusAction = createAsyncThunk(
    'price/updateAutomaticExpirationPromotionSettingStatusAction',
    async (id, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.patch(`${ AUTOMATIC_EXPIRATION_PROMOTION_SETTINGS_PATH }/${ id }/status`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const updateAutomaticExpirationPromotionSettingStatusSlice = createSlice({
    name: 'updateAutomaticExpirationPromotionSettingStatusSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(updateAutomaticExpirationPromotionSettingStatusAction.pending, () => STATE__API__STARTED);
        builder.addCase(updateAutomaticExpirationPromotionSettingStatusAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(updateAutomaticExpirationPromotionSettingStatusAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const updateAutomaticExpirationPromotionSettingStatusState = (state) => state.price.updateAutomaticExpirationPromotionSettingStatus;
export default updateAutomaticExpirationPromotionSettingStatusSlice.reducer;